import App from './app.jsx'
import hyperdom from 'hyperdom'
import router, {redirect} from './router.js'
import {PaymentMethods} from './defaultFlow/index.js'
import {polyfill as smoothScrollPolyfill} from 'seamless-scroll-polyfill'

if (window.bookingServicesConfig) {
  redirect('/tour/' + window.bookingServicesConfig.sellingCompanyCode)
}

const availablePaymentMethods = window.availablePaymentMethods && window.availablePaymentMethods
  .reduce((acc, paymentMethod) => {
    acc.push(PaymentMethods[paymentMethod])
    return acc
  }, [])

hyperdom.append(
  document.body,
  new App({
    config: window.bookingServicesConfig,
    pageNotFound: window.pageNotFound,
    availablePaymentMethods,
  }),
  {router}
)

smoothScrollPolyfill()